const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
});

const numberFractionFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
});

const unsafeListFormatter = new (Intl as any).ListFormat('en-US', {
    style: 'long',
    type: 'conjunction',
});

const listFormatter = unsafeListFormatter.format.bind(unsafeListFormatter);

export type Formatable = number | bigint | string | null | undefined;

export function formatCurrency(value: Formatable): string {
    if (value === null || value === undefined || value === '') return '';
    const n = typeof value === 'string' ? Number(value) : value;
    if (typeof n === 'bigint') return currencyFormatter.format(Number(n));
    if (Number.isNaN(Number(n))) return String(value);
    return currencyFormatter.format(Number(n));
}

export function formatNumber(value: Formatable): string {
    if (value === null || value === undefined || value === '') return '';
    const n = typeof value === 'string' ? Number(value) : value;
    if (typeof n === 'bigint') return numberFormatter.format(Number(n));
    if (Number.isNaN(Number(n))) return String(value);
    return numberFormatter.format(Number(n));
}

export function formatNumberFraction(value: Formatable): string {
    if (value === null || value === undefined || value === '') return '';
    const n = typeof value === 'string' ? Number(value) : value;
    if (typeof n === 'bigint') return numberFractionFormatter.format(Number(n));
    if (Number.isNaN(Number(n))) return String(value);
    return numberFractionFormatter.format(Number(n));
}

export function formatList(items: Array<string | number>): string {
    if (!Array.isArray(items)) return '';
    return listFormatter(items.map(String));
}

const utils = {
    formatCurrency,
    formatNumber,
    formatNumberFraction,
    formatList,
};

export default utils;